module.exports = __webpack_public_path__ + "img/add.19da1637.png";